import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IconModule } from '@hglobal/common';

@Component({
  selector: 'pt-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule],
})
export class SwitcherComponent {
  iconNames = input<[string, string]>(['light', 'dark']);
  isFirst = input<boolean, unknown>(false, { transform: booleanAttribute });
  clicked = output<void>();
}
